<template>
  <b-modal id="add_reg_number_modal" ref="add_reg_number_modal" hide-footer no-close-on-esc no-close-on-backdrop>
    <div slot="modal-header" class="mh">
      <div id="mh-text">
        <h1><i class="fas fa-city"></i> <span>Add Company Reg Number</span></h1>
        <p id="mh-info">Add a Registration Number for {{ $store.state.companies.reg_modal.company_name }}</p>
      </div>
      <button id="mh-close" class="btn-close" @click="hideModal()"><i class="fas fa-times"></i></button>
    </div>
    <div>

      <h4>Results for company from Companies House:</h4>
      <p>As the company should be registered with Companies House if the business does not appear in the list below then it is more than likely that you have the company name
        incorrectly spelt in the CRM.</p>
      <div class="ch_company_house_results">
        <div class="row ml-0 mr-0" v-for="res in ch_company_search_results">
          <div class="col-9">
            <h5 class="bp_color mb-0">{{ res.title }}</h5>
            <h5 class="mb-0">{{ res.company_number }}</h5>

          </div>
          <div class="col-3">
            <button class="btn orcaBtn sm_btn w-100" @click="select_company(res.company_number, res.title)" :class="{'disabled': is_this_ltd_number(res.company_number)}"
                    :disabled="is_this_ltd_number(res.company_number)">Select</button>
          </div>
          <div class="col-12">
            <p class="mb-0">{{ res.address_snippet }}</p>
          </div>
        </div>
      </div>

      <ValidationObserver ref="addRegNumberForm" slim>
        <form role="form" @submit.prevent="add_reg_number()">
          <div class="row">
            <div class="col-8 form-group">
              <ValidationProvider rules="ltdCompNoValidate" v-slot="{errors, classes}" name="LTD Reg Number" tag="div">
                <label class="form-label" for="ltd_reg_number">LTD Registration Number</label>
                <input type="text" v-model="ltd_reg_number" id="ltd_reg_number" name="ltd_reg_number" class="form-input" :class="classes">
                <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>
            <div class="col-4 form-group">
              <button class="btn orcaBtn danger" @click="clear_ltd_num" :class="{'disabled': is_ltd_blank}" :disabled="is_ltd_blank">
                <i class="fas fa-times"></i> &nbsp;&nbsp; Clear</button>
            </div>
            <div class="col-6 offset-6">
              <button :disabled="is_ltd_blank" class="btn orcaBtn" :class="{'disabled': is_ltd_blank}">Save</button>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "add_reg_number_modal",
  data() {
    return {
      ch_company_search_results: [],
      ltd_reg_number: "",
      company_name: ''
    }
  },
  beforeMount() {
    this.search_companies_house();
  },
  computed: {
    is_ltd_blank() {
      return this.ltd_reg_number === '';
    },
  },
  methods: {
    hideModal() {
      this.$refs.add_reg_number_modal.hide();
      this.$store.commit('HIDE_REG_MODALS');
    },
    add_reg_number() {
      let sub_company = {
        company_name: this.company_name,
        log_by_type: 'App\\Models\\Users\\User',
        log_by_id: this.$store.state.auth.me.id
      }

      axios.patch(this.crmApiPath + 'company/' + this.$store.state.companies.reg_modal.company_id, sub_company).then(() => {
        let sub_profile = {
          company_id: this.$store.state.companies.reg_modal.company_id,
          ltd_reg_number: this.ltd_reg_number,
          log_by_type: 'App\\Models\\Users\\User',
          log_by_id: this.$store.state.auth.me.id
        }
        axios.patch(this.crmApiPath + 'company/profile/' + this.$store.state.companies.reg_modal.company_id, sub_profile).then(() => {
          this.hideModal();
          this.$bus.$emit('logs::reload', {action: true});
          this.$bus.$emit('company::reload', {action: true});
        })
      });
    },
    search_companies_house() {
      axios.post(this.crmApiPath + 'hmrc/company/search', {company_name: this.$store.state.companies.reg_modal.company_name}).then(companies => {
        this.ch_company_search_results = companies.data.filter(comp => comp.company_status !== 'dissolved');
      })
    },
    select_company(reg_number, company_name) {
      this.ltd_reg_number = reg_number;
      this.company_name = company_name;
    },
    clear_ltd_num() {
      this.ltd_reg_number = "";
    },
    is_this_ltd_number(reg_num) {
      return this.ltd_reg_number === reg_num;
    }
  }
}
</script>

<style lang="scss">
#add_reg_number_modal {
  .ch_company_house_results {
    max-height: 300px;
    overflow:   scroll;
    border:     2px solid $bc_5;
    padding:    0;
    margin-bottom: 20px;

    .row {
      border-bottom: 1px solid lighten($bc_5, 15%);
      padding:    10px 0;

      &:last-of-type {
        border-bottom: none;
      }
    }
  }
}
</style>
